import Auth from '@/store/modules/auth/constants';

export default {
  [Auth.mutationTypes.setUserLoading](state, loading) {
    const localState = state;

    localState.loading = loading;
  },

  [Auth.mutationTypes.setIsAuthorized](state, isAuthorized) {
    const localState = state;

    localState.isAuthorized = isAuthorized;
  },

  [Auth.mutationTypes.setUserInfo](state, info) {
    const localState = state;

    localState.userInfo = info;
  },
};
